import { Link } from "react-router-dom";
import Logo from "./Logo";

const COLS = [
  { title: "Explore", links: [["Discover", "/discover"], ["Songs", "/songs"], ["Community", "/community"], ["Premium", "/premium"]] },
  { title: "Company", links: [["About", "/about"], ["FAQ", "/faq"], ["Help & Support", "/support"], ["Copyright Report", "/copyright"]] },
  { title: "Legal", links: [["Privacy Policy", "/legal/privacy"], ["Terms of Service", "/legal/terms"], ["Community Guidelines", "/legal/community"]] },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0a0710] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Logo size={44} showText />
          <p className="mt-4 text-sm text-muted-foreground max-w-xs">Sing. Record. Share. A global stage for every voice.</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="font-head font-bold text-sm mb-4 uppercase tracking-widest text-white/80">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={to}><Link to={to} className="text-sm text-muted-foreground hover:text-neon-cyan transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5 py-6 px-6 text-center">
        <p className="text-xs text-muted-foreground">© 2026 SINGVI KARAOKE. An independent product, not affiliated with any other social singing platform. Catalog contains royalty-free, original and licensed content only.</p>
      </div>
    </footer>
  );
}
